/** Which presentation to use. The 3D station needs room for a 640×480 CSS panel; phones get the plain terminal. */
const params = new URLSearchParams(location.search);
export const narrow = () => window.innerWidth < 720 || window.innerHeight < 480;
export const defaultStationView = (): boolean => {
  const v = params.get("view");
  if (v === "screen") return false;
  if (v === "station") return true;
  return !narrow();
};
